var ezdia;
(function (ezdia) {
    var TEMPLATES = ezdia.templates.content;
    function resetGridWidthAndForm(isHideForm) {
        if (isHideForm) {
            ezdia.component.form.hide();
        }
        else {
            ezdia.component.form.show();
        }
    }
    function toggleQuickLinks(selIds, clicked) {
        var id = this.id;
        var checked = $("#cb_" + id).is(':checked');
        if (!selIds.length) {
            $.ezdia.quickLinks.triggersOff('#ez-quick-action-links');
        }
        else if ((selIds.length === 1 && clicked) || checked) {
            $.ezdia.quickLinks.triggersOn('#ez-quick-action-links');
        }
    }
    function reloadActiveMsg() {
        var wrapper = ezdia.util.getWrapper('ez-js-sys-desk-item-reload');
        wrapper
            .html('Changes on server are not synced with local data. Do you want to Sync it now?')
            .dialog({
            modal: true,
            title: 'Sync Pending',
            width: 400,
            height: 200,
            buttons: [
                {
                    text: 'Close',
                    class: 'btn-link',
                    click: function () {
                        $(this).dialog('close');
                    }
                },
                {
                    text: 'Sync Now',
                    class: 'btn-primary',
                    click: function () {
                        $(this).dialog('close');
                        hideShowDeskForm();
                        selectAllClick();
                        $('#grid').trigger('reloadGrid');
                        $('#selectAll').prop('checked', false);
                    }
                }
            ]
        });
    }
    function getNextRowId(row) {
        var id;
        // eslint-disable-next-line consistent-return
        row.nextAll().each(function each() {
            var elem = $(this);
            var reload = elem.data('reload');
            if (reload) {
                //
            }
            else {
                id = elem.attr('id');
                return false;
            }
        });
        return id;
    }
    function quickAction() {
        var listItems = '';
        var arr = [];
        var quickactionObj = ezdia.config.pageParams.quickactionObj;
        listItems = $.ezdia.quickLinks.create(quickactionObj, arr, true);
        if (listItems) {
            $('#qactiondiv').html(listItems);
            $.ezdia.quickLinks.triggersActive('#ez-quick-action-links');
        }
    }
    function handelClickAddRules() {
        var query = $('#searchFrm').search('getQueryString');
        if (query) {
            $('#assignRule').val(query);
            document.getElementById('assignForm').submit();
        }
        else {
            ezdia.util.showSuccessError({
                message: 'Please select a search criteria',
                error: true
            });
        }
    }
    function handelEmailContent() {
        var container = $("#emailAddInfo");
        var isChecked = this.checked;
        if (isChecked) {
            var htmlContent = TEMPLATES.expertManagementEmail();
            container.html(htmlContent);
            $.ezdia.html.create({
                editor: {
                    emailInfo: { name: "emailInfo" }
                }
            });
        }
        else {
            container.empty();
        }
    }
    function expertManagement() {
        var htmlContentInfo = TEMPLATES.expertManagementInfo();
        $("#expert-management-info").html(htmlContentInfo);
        var htmlContentForm = TEMPLATES.expertManagementForm();
        $("#primary-form").html(htmlContentForm);
        $("#taskRuleAssignment").on('click', handelClickAddRules);
        $("#openProjEmail").on('click', handelEmailContent);
    }
    function getPageHeadingProps() {
        var _a = ezdia.config.pageParams, role = _a.role, roleLabel = _a.roleLabel;
        var props = {
            classes: "ez-open-project-pagehead",
            backBtn: {
                href: "ListOpenProjects.htm?role=" + role + "&roleLabel=" + roleLabel,
                title: 'Back to Open Projects'
            },
            pageTitle: {
                pageLabel: 'Open Projects',
                title: 'Select Items to Checkout'
            }
        };
        return props;
    }
    function renderOpenProjectsHelp() {
        var htmlcontent = TEMPLATES.openProjectsHelp();
        $("#primary-help").replaceWith(htmlcontent);
    }
    function checkoutAjax(taskIds) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, accountName, roleName, message, error_1;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        ezdia.util.loading.enable();
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, 4, 5]);
                        _a = ezdia.config.pageParams, accountName = _a.account, roleName = _a.role;
                        return [4 /*yield*/, ezdia.Http.get({
                                url: 'AcceptTask.htm',
                                data: {
                                    accountName: accountName,
                                    roleName: roleName,
                                    taskIds: taskIds.join(',')
                                }
                            })];
                    case 2:
                        message = (_b.sent()).message;
                        ezdia.util.showSuccessError({
                            message: message
                        });
                        return [3 /*break*/, 5];
                    case 3:
                        error_1 = _b.sent();
                        ezdia.util.showSuccessError({
                            message: error_1.message || 'Error updating data. Please try again.',
                            error: true,
                            autohide: false
                        });
                        if (!error_1.message) {
                            console.error(error_1);
                        }
                        return [3 /*break*/, 5];
                    case 4:
                        ezdia.util.loading.disable();
                        return [7 /*endfinally*/];
                    case 5: return [2 /*return*/];
                }
            });
        });
    }
    function returnToQueueConfirm(data) {
        return __awaiter(this, void 0, void 0, function () {
            var _a, returnedByRole, accountName, ids, reqData, response, error_2;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = ezdia.config.pageParams, returnedByRole = _a.role, accountName = _a.account;
                        ids = getGridSelRow();
                        reqData = __assign(__assign({}, data), { returnedByRole: returnedByRole,
                            accountName: accountName, id: ids.join(','), type: 'returnToQueue' });
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, ezdia.Http.post({
                                url: 'ReturnToQueue.htm',
                                data: reqData,
                                dataType: 'text'
                            })];
                    case 2:
                        response = _b.sent();
                        if (response.indexOf('successfully') !== -1) {
                            hideShowDeskForm();
                            $('#grid').trigger('reloadGrid');
                            $('#content').html('');
                            $('#bulkEditFrm').hide();
                            $('#updateBtnContainer').hide();
                            ezdia.util.showSuccessError({
                                message: response
                            });
                        }
                        else {
                            ezdia.util.showSuccessError({
                                message: response,
                                error: true,
                                autohide: false
                            });
                        }
                        return [3 /*break*/, 4];
                    case 3:
                        error_2 = _b.sent();
                        ezdia.util.showSuccessError({
                            message: 'An error occurred while processing your request. Please try again.',
                            error: true,
                            autohide: false
                        });
                        console.error(error_2);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        });
    }
    function returnToOpenProjects(data) {
        $('#statusMsg').html("You are about to return this item back to Open Projects Queue.<br/>Are you sure you want to do this?");
        $('#statusMsg').dialog({
            modal: true,
            width: 'auto',
            title: 'Confirm',
            buttons: {
                YES: function () {
                    $(this).dialog('close');
                    returnToQueueConfirm(data);
                },
                NO: function () {
                    $(this).dialog('close');
                }
            }
        });
    }
    function handelReturnItemConfirm(formId) {
        var _a = ezdia.config.pageParams, roleType = _a.roleType, role = _a.role;
        var form = document.getElementById(formId);
        var formData = new FormData(form);
        var returnRole = formData.get('returnOption');
        var comments = formData.get('ret_comments');
        var _b = __read(returnRole.split('__'), 2), returnRoleValue = _b[0], returnDataVal = _b[1];
        $('#ez-return-comments').val(comments);
        if (roleType === 'pm' && returnDataVal === 'open_project') {
            returnToOpenProjects({
                role: returnRoleValue,
                ret_comments: comments
            });
        }
        else if (returnRoleValue === 'open_project') {
            returnToOpenProjects({
                role: role,
                ret_comments: comments
            });
        }
        else {
            saveUpdateReturnItem('Return Item', {
                type: 'return',
                returnItemName: returnDataVal,
                ret_comments: comments
            });
        }
    }
    function handelReturnItem() {
        var _a = ezdia.config, _b = _a.pageParams, currentStatus = _b.currentStatus, role = _b.role, returnOptions = _a.JS.itemMetaData.returnOptions;
        if (!returnOptions || !Object.keys(returnOptions).length) {
            ezdia.alert('Status Update', 'No return options are available for the item');
            return;
        }
        if (role === 'pm' ||
            (currentStatus &&
                (currentStatus.includes('Assigned') ||
                    currentStatus.includes('Saved') ||
                    currentStatus.includes('Reopened') ||
                    currentStatus.includes('Reassigned') ||
                    currentStatus.includes('New')))) {
            var formId_1 = ezdia.util.makeId();
            var htmlContent = TEMPLATES.getReturnOptionsMsg(returnOptions, formId_1);
            var wrap = ezdia.util.getWrapper('ez-js-return-item');
            wrap.html(htmlContent);
            wrap.dialog({
                modal: true,
                width: '400',
                title: 'Status Update',
                buttons: [
                    {
                        text: 'Return',
                        class: 'btn-primary',
                        click: function () {
                            handelReturnItemConfirm(formId_1);
                            $(this).dialog('close');
                        }
                    },
                    {
                        text: 'Cancel',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        }
        else {
            $('#statusMsg').html('Whoa! You can only edit items that are Assigned, Saved, or Reopened.');
            $('#statusMsg').dialog({
                modal: true,
                width: 'auto',
                title: 'Status Update',
                buttons: {
                    Ok: function () {
                        $(this).dialog('close');
                    }
                }
            });
        }
    }
    function handelDownloadWordDoc() {
        var id = getGridSelRow();
        var url = 'wordDownload.htm';
        var _a = ezdia.config.pageParams, account = _a.account, role = _a.role;
        $.fileDownload(url, {
            failMessageHtml: 'There was a problem generating the document, please try again.',
            httpMethod: 'POST',
            datatype: 'json',
            data: {
                accountName: function () {
                    return escape(account);
                },
                role: function () {
                    return escape(role);
                },
                id: function () {
                    return id;
                }
            },
            failCallback: function () {
                ezdia.alert('Error');
                $('#error-modal').dialog({ modal: true });
            }
        });
    }
    function saveUpdateReturnItem(type, optdata) {
        if (optdata === void 0) { optdata = {}; }
        $(this).button('loading');
        var _a = ezdia.config.JS, currentAccountKey = _a.currentAccountKey, activityTime = _a.activityTime;
        var value = this.value;
        var data = __assign({}, optdata);
        var btnLabel = type;
        var form = 'updateFrm';
        if (value === 'Bulk Update') {
            form = 'bulkEditFrm';
            data.accountName = $('#accountName').val();
            data.role = $('#role').val();
            data.id = "" + getGridSelRow();
            data.type = 'bulkedit';
        }
        else {
            // eslint-disable-next-line no-underscore-dangle
            data._id = "" + getGridSelRow();
            if ($.ezdia.config.iseditor) {
                tinyMCE.triggerSave();
            }
            var isValidate = validateFields(btnLabel);
            if (isValidate || !$("#" + form).valid()) {
                $(this).button('reset');
                return;
            }
            var totalTimeKey = currentAccountKey + ".desk.total.time";
            var startTimeKey = currentAccountKey + ".desk.start.time";
            var startTime = '';
            var totalTime = '';
            data.content_warning = $('#edWarnings').html();
            data.content_warning_count = $('#edWarnings [data-message="message"]').length;
            data.accountName = $('#accountName').val();
            data.role = $('#role').val();
            data.btnlabel = value;
            if (activityTime[startTimeKey]) {
                startTime = activityTime[startTimeKey];
                totalTime = activityTime[totalTimeKey];
            }
            else {
                startTime = localStorage[startTimeKey];
                totalTime = localStorage[totalTimeKey];
            }
            data.desk_start_time = startTime;
            data.desk_total_time = totalTime;
            data.desk_end_time = getCurrentDateTime();
            if (btnLabel === 'Submit' || btnLabel === 'Submit And Next') {
                data.type = 'submit';
                data.btnLabel = btnLabel;
            }
            else if (btnLabel === 'Update') {
                data.type = 'update';
            }
            else if (btnLabel === 'Save') {
                data.type = 'save';
            }
            saveDataNow(data, $(this), form);
        }
    }
    function checkOnlineAndTrigger(callback) {
        if ('onLine' in window.navigator && !window.navigator.onLine) {
            $('#statusMsg').html('You seem to be Offline.');
            $('#statusMsg').dialog({
                modal: true,
                title: 'Network Connection',
                width: 500,
                height: 200,
                buttons: [
                    {
                        text: 'Close',
                        class: 'btn-link',
                        click: function () {
                            $(this).dialog('close');
                        }
                    }
                ]
            });
        }
        else {
            callback.call(this);
        }
    }
    function bindButtonClick(buttons) {
        buttons.forEach(function (_a) {
            var id = _a.id, onClick = _a.onClick, group = _a.group;
            if (onClick) {
                var elem = document.getElementById(id);
                elem.addEventListener('click', checkOnlineAndTrigger.bind(elem, onClick));
            }
            if (group) {
                var gid = group.id, gonClick = group.onClick;
                var elem = document.getElementById(gid);
                elem.addEventListener('click', checkOnlineAndTrigger.bind(elem, gonClick));
                //
            }
        });
    }
    function renderButtons() {
        var buttons = [];
        var _a = ezdia.config.pageParams, isMyTask = _a.isMyTask, account = _a.account, role = _a.role, userRole = _a.user_role;
        var _b = userRole || {}, returns = _b.returns, userRoleT = _b.type, userRoleConfig = _b.config, editBtnLabels = _b.editBtnLabels;
        if (isMyTask) {
            if (!'getStepActions') {
                // TODO: Check if this is in use
            }
            else {
                if (returns && returns.length) {
                    buttons.push({
                        name: 'return',
                        id: 'returnItemBtn',
                        value: 'Return Item',
                        dataType: 'Return Item',
                        loadingText: 'Updating...',
                        label: 'Return Item',
                        icon: 'glyphicon glyphicon-backward',
                        onClick: handelReturnItem
                    });
                }
                buttons.push({
                    name: 'downloadWordDoc',
                    id: 'downloadWordDocBtn',
                    label: 'Download Data in Word',
                    value: 'Download Data in Word',
                    style: 'display:none;',
                    onClick: handelDownloadWordDoc
                });
                if (account !== 'expert' &&
                    userRoleT !== 'customer' &&
                    userRoleT !== 'pm' &&
                    (!(userRoleConfig === null || userRoleConfig === void 0 ? void 0 : userRoleConfig.client) ||
                        userRoleConfig.client.saveBtn === null ||
                        userRoleConfig.client.saveBtn)) {
                    buttons.push({
                        name: 'save',
                        id: 'saveBtn',
                        value: 'Save',
                        dataType: 'Save',
                        loadingText: 'Saving...',
                        label: 'Save',
                        icon: 'glyphicon glyphicon-folder-open',
                        onClick: function () {
                            saveUpdateReturnItem.call(this, 'Save');
                        }
                    });
                }
                if (userRoleT === 'pm' || userRoleT === 'customer') {
                    buttons.push({
                        name: 'update',
                        id: 'updateBtn',
                        value: 'Update',
                        dataType: 'Update',
                        loadingText: 'Updating...',
                        label: 'Update',
                        icon: 'fa fa-retweet',
                        onClick: function () {
                            saveUpdateReturnItem.call(this, 'Update');
                        }
                    });
                }
                if (account !== 'expert' && userRoleT !== 'pm' && userRoleT !== 'customer') {
                    buttons.push({
                        id: 'submitAndNextBtn',
                        value: 'Submit',
                        dataType: 'Submit And Next',
                        loadingText: 'Submitting...',
                        label: 'Submit And Next',
                        onClick: function () {
                            saveUpdateReturnItem.call(this, 'Submit And Next');
                        },
                        group: {
                            name: 'submit',
                            id: 'submitBtn',
                            value: 'Submit',
                            dataType: 'Submit',
                            loadingText: 'Submitting...',
                            label: 'Submit',
                            icon: 'glyphicon glyphicon-forward',
                            onClick: function () {
                                saveUpdateReturnItem.call(this, 'Submit');
                            }
                        }
                    });
                    buttons.push({
                        id: 'submitSingleBtn',
                        value: 'Submit',
                        dataType: 'Submit',
                        loadingText: 'Submitting...',
                        label: 'Submit',
                        icon: 'glyphicon glyphicon-forward',
                        onClick: function () {
                            saveUpdateReturnItem.call(this, 'Submit');
                        }
                    });
                }
            }
        }
        if (editBtnLabels && editBtnLabels.length) {
            // TODO: Check if in use
        }
        var htmlContent = TEMPLATES.getUpdateBtns(buttons);
        $("#updateBtnContainer").html(htmlContent);
        bindButtonClick(buttons);
    }
    var Content = /** @class */ (function () {
        function Content() {
        }
        // eslint-disable-next-line class-methods-use-this
        Content.prototype.resetGridData = function (id) {
            var grid = $('#grid');
            var row = grid.find('.ui-state-highlight');
            var nextRowId = getNextRowId(row);
            row.addClass('bg-warning').data('reload', true);
            grid.jqGrid('resetSelection');
            $('#selectAll').attr('disabled', 'disabled');
            $('#cb_grid').attr('disabled', 'disabled');
            $("#jqg_grid_" + id).attr('disabled', 'disabled');
            if (nextRowId) {
                grid.jqGrid('setSelection', nextRowId, true);
                $('html,body').animate({
                    scrollTop: $('#updateFrm').offset().top
                }, 'slow');
            }
        };
        Content.prototype.render = function (pageType) {
            var title = 'Content';
            if (pageType === 'MyOpenTask') {
                title = 'Open projects';
            }
            ezdia.util.setTitle(title);
            if (pageType !== "ExpertManagement") {
                var pageHeadingProps = {};
                if (pageType === 'MyOpenTask') {
                    pageHeadingProps = getPageHeadingProps();
                }
                ezdia.component.pageFiltersAndHeading.render(pageHeadingProps);
            }
            else {
                var accountLabel = ezdia.config.pageParams.accountLabel;
                ezdia.component.pageFiltersAndHeading.renderTitle({
                    pageLabel: accountLabel,
                    title: ''
                });
                expertManagement();
            }
            if (pageType === 'MyOpenTask') {
                renderOpenProjectsHelp();
            }
            renderButtons();
            this.search();
            this.events();
            if (pageType !== "ExpertManagement") {
                quickAction();
            }
        };
        // eslint-disable-next-line class-methods-use-this
        Content.prototype.checkout = function () {
            var ids = ezdia.util.getSelectedGridItemsIds();
            if (!ids || !ids.length) {
                ezdia.util.showSuccessError({
                    message: "Please select at least one item",
                    error: true
                });
            }
            else {
                checkoutAjax(ids);
            }
        };
        Content.prototype.search = function () {
            var e_1, _a;
            var _b = ezdia.config.pageParams, paramQueueId = _b.paramQueueId, paramAccName = _b.paramAccName, paramRole = _b.paramRole, basicSearchFields = _b.basicSearchFields, searchFields = _b.searchFields, isMyOpenTask = _b.isMyOpenTask, isQueueManagement = _b.isQueueManagement, sysSavedSearch = _b.sysSavedSearch, requestParam = _b.requestParam, userSavedSearch = _b.userSavedSearch, exportCols = _b.exportCols;
            var savedQuerys = [];
            var htmlcontent = ezdia.templates.serach.basicHtmlContent();
            $("#primary-search").replaceWith(htmlcontent);
            if (userSavedSearch && userSavedSearch.length) {
                try {
                    for (var userSavedSearch_1 = __values(userSavedSearch), userSavedSearch_1_1 = userSavedSearch_1.next(); !userSavedSearch_1_1.done; userSavedSearch_1_1 = userSavedSearch_1.next()) {
                        var name_1 = userSavedSearch_1_1.value.name;
                        savedQuerys.push(name_1);
                    }
                }
                catch (e_1_1) { e_1 = { error: e_1_1 }; }
                finally {
                    try {
                        if (userSavedSearch_1_1 && !userSavedSearch_1_1.done && (_a = userSavedSearch_1.return)) _a.call(userSavedSearch_1);
                    }
                    finally { if (e_1) throw e_1.error; }
                }
            }
            var searchParams = {
                enablebasic: true,
                searchOnLoad: true,
                basic: {
                    queryfields: basicSearchFields
                },
                advance: {
                    savedQuerys: savedQuerys,
                    queryfields: searchFields
                },
                callbacks: {
                    search: this.create.bind(this),
                    export: function ex(query) {
                        ezdia.component.exportGridData(this, {
                            query: query,
                            exportCols: exportCols
                        });
                    }
                }
            };
            if (paramQueueId &&
                paramQueueId > 0 &&
                paramAccName === 'expert' &&
                paramRole === 'pm') {
                //
            }
            else if (!isMyOpenTask) {
                searchParams.requestParam = requestParam;
                if (sysSavedSearch && !isQueueManagement) {
                    searchParams.setSelection = true;
                }
            }
            $('#searchFrm').search(searchParams);
        };
        Content.prototype.create = function (query, queryName) {
            var pageParams = $.ezdia.config.pageParams;
            var tab = pageParams.tab, colModel = pageParams.colModel, colNames = pageParams.colNames, groups = pageParams.groups, rowNum = pageParams.rowNum, account = pageParams.account, role = pageParams.role, requestParam = pageParams.requestParam, submitFields = pageParams.submitFields;
            var _a = this, beforeSelectRow = _a.beforeSelectRow, onSelectRow = _a.onSelectRow, onSortCol = _a.onSortCol, loadComplete = _a.loadComplete;
            pageParams.fetchFields = [];
            ezdia.component.grid.create({
                colNames: colNames,
                colModel: colModel,
                groups: groups,
                rowNum: rowNum,
                beforeSelectRow: beforeSelectRow,
                onSelectRow: onSelectRow,
                onSortCol: onSortCol,
                id: 'grid',
                url: 'FetchData.htm',
                datatype: 'json',
                mtype: 'POST',
                postData: {
                    tab: tab,
                    accountName: escape(account),
                    role: escape(role),
                    orderedFetchFields: function () {
                        return pageParams.fetchFields;
                    },
                    searchString: query,
                    key: function () {
                        if (!requestParam) {
                            return "";
                        }
                        var reqParam = requestParam;
                        if (typeof requestParam === 'string') {
                            reqParam = ezdia.util.jsonParse(reqParam) || {};
                        }
                        return reqParam.key ? reqParam.key[0] : '';
                    },
                    customSearchName: queryName || ''
                },
                onSelectAll: onSelectRow,
                multiselect: isGridMultiSelect(),
                loadComplete: loadComplete,
                afterInsertRow: function (id, data) {
                    var status = submitFields;
                    var c;
                    if (status) {
                        switch (data[status]) {
                            case 'Returned':
                                c = 'returned';
                                break;
                            case 'Reopened':
                                c = 'reopened';
                                break;
                            case 'Submitted':
                                c = 'submitted';
                                break;
                            default:
                                break;
                        }
                        if (c) {
                            $("tr#" + id).addClass(c);
                        }
                    }
                },
                searchFrm: '#searchFrm',
                customeBtnsWrapId: 'ez-js-grid-actions-btns',
                hidegrid: false,
                gridview: true
            });
        };
        Content.prototype.beforeSelectRow = function (rowid, event) {
            var grid = $(this);
            var target = event.target, ctrlKey = event.ctrlKey;
            var $target = $(target);
            var row = $target.closest('tr');
            var selectAll;
            var multiselect;
            if (row.data('reload')) {
                reloadActiveMsg();
                selectAll = true;
            }
            else {
                multiselect = grid.jqGrid('getGridParam', 'multiselect');
                selectAll = $('#selectAll').is(':checked');
                if (isGridMultiSelect()) {
                    var isCheckbox = $target.is(':checkbox');
                    var cbox = $target.hasClass('cbox');
                    var targetCell = $target.attr('aria-describedby') === 'grid_cb';
                    if (grid.jqGrid('getGridParam', 'selrow') !== rowid &&
                        !isCheckbox &&
                        !cbox &&
                        !ctrlKey &&
                        !targetCell) {
                        grid.jqGrid('resetSelection');
                    }
                }
                if (!multiselect && grid.jqGrid('getGridParam', 'selrow') === rowid) {
                    grid.jqGrid('setGridParam', { deselectrow: true });
                }
            }
            return !selectAll;
        };
        // eslint-disable-next-line class-methods-use-this
        Content.prototype.onSelectRow = function (ids, clicked, e) {
            var selIds = getGridSelRow();
            if (!(e === null || e === void 0 ? void 0 : e.ctrlKey) && (selIds === null || selIds === void 0 ? void 0 : selIds.length) === 1) {
                $('body').css('cursor', 'progress');
                ezdia.component.grid.loading.show();
            }
            setTimeout(function () {
                ezdia.pages.content.renderForm(ids, clicked, e);
                if (selIds && selIds.length === 1) {
                    ezdia.component.grid.loading.hide();
                    $('body').css('cursor', '');
                }
            }, 0);
        };
        // eslint-disable-next-line class-methods-use-this
        Content.prototype.loadComplete = function () {
            var pageParams = ezdia.config.pageParams;
            var _a = pageParams || {}, isMyTask = _a.isMyTask, sysSelectFirst = _a.sysSelectFirst, sysQuickAction = _a.sysQuickAction;
            var _b = ezdia.templates.grid, countAndSelectCaption = _b.countAndSelectCaption, caption = _b.caption;
            hideShowDeskForm();
            if (isMyTask) {
                var recordCount = $('#grid').jqGrid('getGridParam', 'records');
                var rowNum = $('#grid').jqGrid('getGridParam', 'rowNum');
                var gridCaption = 'Items';
                if (isGridMultiSelect() && recordCount > rowNum) {
                    gridCaption = countAndSelectCaption(recordCount);
                }
                gridCaption = caption(gridCaption);
                $('#grid').jqGrid('setCaption', gridCaption);
            }
            else {
                var gridCaption = 'Items';
                gridCaption = caption(gridCaption);
                $('#grid').jqGrid('setCaption', gridCaption);
            }
            resetGridWidthAndForm(true);
            setGridCellTitle();
            if (sysSelectFirst) {
                $.ezdia.grid.selectFirstItem('#grid');
            }
            if (sysQuickAction &&
                sysQuickAction !== 'null' &&
                sysQuickAction !== '') {
                $.ezdia.grid.quickAction('grid');
            }
            ezdia.component.grid.loading.create();
            $('#cb_grid').removeAttr('disabled');
            pageLoadingDone();
        };
        // eslint-disable-next-line class-methods-use-this
        Content.prototype.onSortCol = function () {
            hideShowDeskForm();
        };
        Content.prototype.renderForm = function (ids, clicked, e) {
            var pageParams = ezdia.config.pageParams;
            var account = pageParams.account, roleType = pageParams.roleType;
            var isCBClick = ezdia.util.gridCBClick(e);
            var selIds = ezdia.util.getSelectedGridItemsByGridId();
            // eslint-disable-next-line no-param-reassign
            e = e || {};
            if (selIds && selIds.length > 1) {
                resetGridWidthAndForm();
                ezdia.component.quickActions.updateSelectedIdsOnView(selIds);
                hideShowDeskForm('#bulkEditFrm');
            }
            else if (ids && selIds.length === 1 && !isCBClick) {
                resetGridWidthAndForm();
                hideShowDeskForm();
                if (!e.ctrlKey) {
                    var id = selIds.toString();
                    ezdia.component.form.renderItem({
                        ids: id,
                        grid: 'grid'
                    });
                }
                if (account !== 'expert' &&
                    roleType !== 'customer' &&
                    roleType !== 'pm') {
                    var submitMultipleBtn = $('#submitMultipleBtn').hide();
                    var submitSingleBtn = $('#submitSingleBtn').hide();
                    var nextChild = $('#grid').find('tr.ui-state-highlight').next('tr');
                    if (nextChild.length) {
                        submitMultipleBtn.show();
                    }
                    else {
                        submitSingleBtn.show();
                    }
                }
            }
            else if (!selIds.length) {
                resetGridWidthAndForm(true);
                hideShowDeskForm('');
            }
            toggleQuickLinks.call(this, selIds, clicked);
        };
        Content.prototype.events = function () {
            $('#ez-js-form-right-close').on('click', function click() {
                $('#grid').jqGrid('resetSelection');
                resetGridWidthAndForm(true);
            });
            $('#acceptBtn').on('click', this.checkout);
        };
        return Content;
    }());
    var pages;
    (function (pages) {
        pages.content = new Content();
    })(pages = ezdia.pages || (ezdia.pages = {}));
})(ezdia || (ezdia = {}));
